import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, MaybeAsync, Resolve, RouterStateSnapshot } from '@angular/router';
import { ServiceAppEntityServiceRead } from '../openapi';
import { Store } from '@ngrx/store';
import { selectServices } from '../store/selectors/app.selectors';
import { filter, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApplicationInfoResolver implements Resolve<ServiceAppEntityServiceRead | null> {
  constructor(private store$: Store) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<ServiceAppEntityServiceRead | null> {
    const url = `/${route.params['contentUrl'] || ''}`;
    return this.store$.select(selectServices).pipe(
      filter(v => !!v.length),
      map(services => services.filter((s) => s.url === url)[0] || null)
    );
  }
}
